import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const FilterPanel = ({
    typeRealEstateSelected,
    typePostRealEstate,
    handleClearFilterSearch,
    typerealEstateSearchHandle,
    setSearchDatafilter,
    searchDataFilter,
    provinceData,
    handleCallAmpuhre,
    districtsData,
    handleCallTambon,
    stausRoleSellerSearchFilterSelected,
    RoleSellerEstaeHandle,
    isStatusRealEstateFirstHand,
    StatusRealEstateFirstHandHandle,
    handleSearchFilther,
    handleCloseModal,  // New prop for closing modal
}) => {
    // State for managing selected price range
    const [selectedPriceRange, setSelectedPriceRange] = useState('');

    const priceRanges = [
        { label: 'ทุกช่วงราคา', value: '0-9999999' },
        { label: '0 - 1,000,000 บาท', value: '0-1000000' },
        { label: '1,000,000 - 3,000,000 บาท', value: '1000000-3000000' },
        { label: '3,000,000 - 5,000,000 บาท', value: '3000000-5000000' },
        { label: '5,000,000 - 7,000,000 บาท', value: '5000000-7000000' },
        { label: '7,000,000 - 15,000,000 บาท', value: '7000000-15000000' },
        { label: '15,000,000 - 300,000,000 บาท', value: '15000000-300000000' },
    ];

    // Save selected price range to localStorage
    const handlePriceSelectChange = (e) => {
        const value = e.target.value;
        setSelectedPriceRange(value);
        localStorage.setItem('selectedPriceRange', value); // Save to localStorage
    };

    // Load price range from localStorage on mount
    useEffect(() => {
        const savedPriceRange = localStorage.getItem('selectedPriceRange');
        if (savedPriceRange) {
            setSelectedPriceRange(savedPriceRange);
        }
    }, []);

    // Sort province data alphabetically by name_th
    const sortedProvinceData = [...provinceData].sort((a, b) => a.name_th.localeCompare(b.name_th, 'th'));

    return (
        <motion.div
            className="fixed bottom-0 left-0 right-0 lg:left-0 lg:right-auto lg:w-[62%] max-h-[88vh] overflow-y-auto bg-white shadow-2xl rounded-t-3xl z-50 pb-10"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
            {/* Drag handle */}
            <div className="flex justify-center pt-3 pb-1">
                <div className="w-10 h-1 bg-gray-200 rounded-full" />
            </div>

            {/* Header */}
            <div className="flex items-center justify-between px-6 py-3 border-b border-gray-100">
                <div>
                    <h4 className="text-lg font-bold text-gray-900">ค้นหาอสังหาฯ</h4>
                    <p className="text-xs text-gray-400">กรองตามเงื่อนไขที่ต้องการ</p>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        className="flex items-center gap-1.5 text-xs font-semibold text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full hover:bg-emerald-100 transition-colors"
                        onClick={handleClearFilterSearch}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        รีเซ็ต
                    </button>
                    <button
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors text-gray-500"
                        onClick={handleCloseModal}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="px-6 space-y-7 mt-5">

                {/* Property Type */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">ประเภทอสังหาริมทรัพย์</p>
                    <div className="grid grid-cols-3 gap-2">
                        {[
                            { type: 'house', label: 'บ้านเดี่ยว' },
                            { type: 'condo', label: 'คอนโด' },
                            { type: 'townhouse', label: 'ทาวน์เฮ้าส์' },
                            { type: 'land', label: 'ที่ดิน' },
                            { type: 'commercial', label: 'เชิงพาณิชย์' },
                            { type: 'other', label: 'อื่นๆ' },
                        ].map(({ type, label }) => (
                            <motion.button
                                key={type}
                                className={`h-10 rounded-xl text-sm font-semibold transition-all border-2 ${
                                    typeRealEstateSelected.includes(type)
                                        ? 'bg-blue-500 text-white border-blue-500 shadow-md shadow-blue-500/20'
                                        : 'bg-gray-50 text-gray-600 border-transparent hover:border-gray-200'
                                }`}
                                onClick={() => typerealEstateSearchHandle(type)}
                                whileTap={{ scale: 0.97 }}
                            >
                                {label}
                            </motion.button>
                        ))}
                    </div>
                </div>

                {/* Sale Type */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">ประเภทการขาย</p>
                    <div className="grid grid-cols-3 gap-2">
                        {[
                            { label: 'ขาย', key: 'sell' },
                            { label: 'เช่า', key: 'rent' },
                            { label: 'เซ้ง', key: 'sell_out' },
                        ].map((data) => (
                            <motion.button
                                key={data.key}
                                className={`h-10 rounded-xl text-sm font-semibold transition-all border-2 ${
                                    typePostRealEstate.includes(data.label)
                                        ? 'bg-blue-500 text-white border-blue-500 shadow-md shadow-blue-500/20'
                                        : 'bg-gray-50 text-gray-600 border-transparent hover:border-gray-200'
                                }`}
                                onClick={() =>
                                    setSearchDatafilter({
                                        ...searchDataFilter,
                                        typePostRealEstate: typePostRealEstate.includes(data.label)
                                            ? typePostRealEstate.filter((type) => type !== data.label)
                                            : [...typePostRealEstate, data.label],
                                    })
                                }
                                whileTap={{ scale: 0.97 }}
                            >
                                {data.label}
                            </motion.button>
                        ))}
                    </div>
                </div>

                {/* Price Range */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">ช่วงราคา</p>
                    <div className="relative">
                        <select
                            className="w-full h-12 bg-gray-50 border-2 border-transparent rounded-xl px-4 outline-none font-medium text-gray-700 focus:border-blue-400 focus:bg-white transition-all appearance-none cursor-pointer"
                            value={selectedPriceRange}
                            onChange={handlePriceSelectChange}
                        >
                            <option value="" disabled>เลือกช่วงราคา</option>
                            {priceRanges.map((range) => (
                                <option key={range.value} value={range.value}>{range.label}</option>
                            ))}
                        </select>
                        <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Location */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">จังหวัด / อำเภอ</p>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="relative">
                            <select
                                className="w-full h-12 bg-gray-50 border-2 border-transparent rounded-xl px-4 outline-none font-medium text-gray-700 focus:border-blue-400 focus:bg-white transition-all appearance-none cursor-pointer"
                                onChange={(e) => handleCallAmpuhre(e.target.value)}
                            >
                                <option value="">เลือกจังหวัด</option>
                                {sortedProvinceData.map((province) => (
                                    <option key={province.id} value={province.id}>{province.name_th}</option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>
                        <div className="relative">
                            <select
                                className="w-full h-12 bg-gray-50 border-2 border-transparent rounded-xl px-4 outline-none font-medium text-gray-700 focus:border-blue-400 focus:bg-white transition-all appearance-none cursor-pointer"
                                onChange={(e) => handleCallTambon(e.target.value)}
                            >
                                <option value="">เลือกอำเภอ</option>
                                {districtsData && districtsData.map((district) => (
                                    <option key={district.id} value={district.id}>{district.name_th}</option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Seller Status */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">สถานะผู้ขาย</p>
                    <div className="grid grid-cols-2 gap-2">
                        {[
                            { key: 'owner', label: 'เจ้าของขายเอง' },
                            { key: 'agent', label: 'ตัวแทนขาย' },
                        ].map(({ key, label }) => (
                            <motion.button
                                key={key}
                                className={`h-10 rounded-xl text-sm font-semibold transition-all border-2 ${
                                    stausRoleSellerSearchFilterSelected === key
                                        ? 'bg-blue-500 text-white border-blue-500 shadow-md shadow-blue-500/20'
                                        : 'bg-gray-50 text-gray-600 border-transparent hover:border-gray-200'
                                }`}
                                onClick={() => RoleSellerEstaeHandle(key)}
                                whileTap={{ scale: 0.97 }}
                            >
                                {label}
                            </motion.button>
                        ))}
                    </div>
                </div>

                {/* Condition */}
                <div>
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">สภาพอสังหาฯ</p>
                    <div className="grid grid-cols-2 gap-2">
                        {['มือหนึ่ง', 'มือสอง'].map((condition, index) => (
                            <motion.button
                                key={index}
                                className={`h-10 rounded-xl text-sm font-semibold transition-all border-2 ${
                                    isStatusRealEstateFirstHand === (condition === 'มือหนึ่ง')
                                        ? 'bg-blue-500 text-white border-blue-500 shadow-md shadow-blue-500/20'
                                        : 'bg-gray-50 text-gray-600 border-transparent hover:border-gray-200'
                                }`}
                                onClick={() => StatusRealEstateFirstHandHandle(condition === 'มือหนึ่ง')}
                                whileTap={{ scale: 0.97 }}
                            >
                                {condition}
                            </motion.button>
                        ))}
                    </div>
                </div>

                {/* Search Button */}
                <motion.button
                    className="w-full py-3.5 bg-blue-500 hover:bg-blue-600 rounded-2xl text-white font-bold text-base shadow-lg shadow-blue-500/25 transition-colors"
                    onClick={handleSearchFilther}
                    whileTap={{ scale: 0.98 }}
                >
                    ค้นหาทรัพย์
                </motion.button>
            </div>
        </motion.div>
    );
};

export default FilterPanel;
